import { FC } from 'react'
import Swal from 'sweetalert2'
import { IconPaths, ModalSize } from '_metronic/helpers'
import { showAlertLoading, showConfirmAlert, showError } from '_metronic/helpers/AlertHelper'
import { useT } from '_metronic/i18n/Metronici18n'
import { RowActions, useModal, useToast } from 'app/components'
import { FornecedorList } from '../../../core/_models'
import {
  deleteFornecedorLogo,
  getFornecedorEdicao,
  updateFornecedor,
} from '../../../core/_requests'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { FornecedorModal } from '../../../components/modal/FornecedorModal'

type Props = { fornecedor: FornecedorList }

export const FornecedoresActionsCell: FC<Props> = ({ fornecedor }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { refetch } = useQueryResponse()
  const { t } = useT()
  const nome = fornecedor.nomeFantasia || fornecedor.nome

  const abrirEdicao = () =>
    showModal({
      title: t('pagina.fornecedores.modal.titulo_editar'),
      description: nome,
      content: <FornecedorModal />,
      size: ModalSize.Large,
      fetchers: { fornecedor: () => getFornecedorEdicao(fornecedor.id) },
    })

  // PUT parcial: no fornecedor, campo ausente mantém o valor salvo.
  const alterarSituacao = async (ativo: boolean) => {
    if (!ativo) {
      const confirmado = await showConfirmAlert({
        title: t('pagina.fornecedores.inativar.titulo'),
        text: t('pagina.fornecedores.inativar.texto', { nome }),
        confirmButtonText: t('pagina.fornecedores.inativar.confirmar'),
        cancelButtonText: t('common.cancel'),
        danger: true,
      })
      if (!confirmado) return
    }
    try {
      showAlertLoading()
      await updateFornecedor(fornecedor.id, { ativo })
      Swal.close()
      showToast({
        variant: 'success',
        title: t(ativo ? 'pagina.fornecedores.ativado' : 'pagina.fornecedores.inativado', { nome }),
      })
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  const removerLogo = async () => {
    const confirmado = await showConfirmAlert({
      title: t('pagina.fornecedores.remover_logo.titulo'),
      text: t('pagina.fornecedores.remover_logo.texto', { nome }),
      confirmButtonText: t('pagina.fornecedores.remover_logo.confirmar'),
      cancelButtonText: t('common.cancel'),
      danger: true,
    })
    if (!confirmado) return
    try {
      showAlertLoading()
      await deleteFornecedorLogo(fornecedor.id)
      Swal.close()
      showToast({ variant: 'success', title: t('pagina.fornecedores.remover_logo.sucesso') })
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  return (
    <RowActions
      itemName={nome}
      primaryAction={{ label: t('common.edit'), onClick: abrirEdicao, icon: IconPaths.Pen }}
      items={[
        fornecedor.ativo
          ? { label: t('pagina.fornecedores.acao.inativar'), onClick: () => alterarSituacao(false) }
          : { label: t('pagina.fornecedores.acao.ativar'), onClick: () => alterarSituacao(true) },
        {
          label: t('pagina.fornecedores.acao.remover_logo'),
          onClick: removerLogo,
          danger: true,
          hidden: !fornecedor.logoCadastrada,
        },
      ]}
    />
  )
}
